import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Button1Component } from './button_1/button-1.component';

// ----------------------------------------------------------------------------------------------------
@NgModule({
  declarations: [
    Button1Component
  ],
  imports: [
    CommonModule
  ],
  exports: [
    Button1Component
  ]
})
export class UiModule { }
